export class AddressModel {
    _id: string;
    name: string;
    mobileNumber: number;
    streetAddress: string;
    building: string;
    landmark: string;
    city: string;
    state: string;
    pincode: string;
    editAddress: boolean;
    firstName: string;
    lastName: string;
    country: string;
    dial_code: string;
}